// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__19zvX","rootSmall":"AddTileButton_rootSmall__waCeP"};